import { render, staticRenderFns } from "./leader_boards.vue?vue&type=template&id=29410510&scoped=true"
import script from "./leader_boards.vue?vue&type=script&lang=js"
export * from "./leader_boards.vue?vue&type=script&lang=js"
import style0 from "./leader_boards.vue?vue&type=style&index=0&id=29410510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29410510",
  null
  
)

export default component.exports